export function addTimezoneOffsetToDate(date: Date, timezoneOffset = 0): Date {
  const localOffset = date.getTimezoneOffset() * 60000
  return new Date(date.getTime() + localOffset + timezoneOffset)
}
